<template>
  <breadcrumb :links="{'/': 'Home', 'current': 'Webcam'}"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3" id="images_container">
    <div class="d-flex align-items-center">
      <i class="bi bi-search p-2"></i>
      <input class="search_bar rounded mt-4 mb-4 form-label" type="text" v-model="searchQuery" placeholder="Cercare per nome">
    </div>
    <ul>
      <li v-for="image in filteredImages" :key="image.id">
        <router-link :to="{ name: 'immagini', params: { id: image.webcam_id } }">
          <img
            :src="'https://monitor.protezionecivile.fvg.it/api/images/' + image.id"
            class="img-fluid rounded"
            :alt="image.webcam_name"
          />
          <div>{{ image.webcam_name }} {{ convertTime(image.dt) }}</div>
        </router-link>
      </li>
      <li></li>
    </ul>
  </div>

  <app-footer></app-footer>
</template>

<style lang="scss" scoped>

.search_bar{
  width: 100%;
  padding: 5px 10px;
  border: 1px #0067b1 solid;
}

#images_container {
  ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
  }

  li {
    height: 25vh;
    flex-grow: 1;
    position: relative;
    margin: 1px;
    div {
      position: absolute;
      bottom: 4px;
      right: 4px;
      color: #eee;
      font-size: 0.7em;
      text-shadow:  -1px 1px 0 #0067b1,
        1px 1px 0 #0067b1,
        1px -1px 0 #0067b1,
        -1px -1px 0 #0067b1;
    }
  }
  li:last-child {
    flex-grow: 10;
  }

  img {
    max-height: 100%;
    min-width: 100%;
    vertical-align: bottom;
  }
  @media (max-aspect-ratio: 1/1) and (max-width: 480px) {
    ul {
      flex-direction: row;
    }

    li {
      height: auto;
      width: 100%;
    }

    img {
      width: 100%;
      max-height: 75vh;
      min-width: 0;
    }
  }
}
</style>

<script>
import MonitorApi from '@/services/MonitorApi';
import AppFooter from '@/app-footer.vue';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: "webcams",
  components: { AppFooter, Breadcrumb },
  data: function() {
    return {
      loader: false,
      images: [],
      searchQuery: "",
    };
  },
  methods: {
    convertTime: function(dt) {
      let time = new Date();
      time.setTime(Date.parse(dt + "Z"));
      const str = time.toLocaleString("it-IT");
      return str.substring(0, str.length - 3);
    },
    showImage(image_id) {
      console.log(image_id);
    },
  },
  computed: {
    filteredImages() {
      return this.images.filter((image) =>
        image.webcam_name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  mounted: async function() {
    this.images = await MonitorApi.getLatestImages();
    this.images.sort((a, b) => {
      var nameA = a.webcam_name.toUpperCase();
      var nameB = b.webcam_name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  },
};
</script>
